<template>
    <v-card>
        <v-card-title>
        <span class="headline">Vessel Type Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newType">
                <v-text-field :label="labels.vesType" v-model="typeForm.vesType" :error-messages="errors.collect('vesType')" data-vv-name="vesType" :data-vv-as="labels.vesType" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.vesType}}</v-subheader>
                <div class="title">{{typeForm.vesType}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="typeForm.vesTypeDesc" :label="labels.vesTypeDesc" :error-messages="errors.collect('vesTypeDesc')" v-validate="'required|entry|max:80'" data-vv-name="vesTypeDesc" :data-vv-as="labels.vesTypeDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'typeForm': Object,
    'newType': Boolean
  },
  data() {
    return {
      labels: {
        vesType: 'Type Code*',
        vesTypeDesc: 'Type Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.typeForm.vesType = undefined
      this.typeForm.vesTypeDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newType) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vessel.menu.createType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.typeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vessel.menu.updateType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.typeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
